<template>
  <div class="shop-order-detail">
    <header class="detail-head">
      <van-icon
        name="arrow-left"
        @click="$router.back()"
      />
      <h1>{{ detailTitle }}</h1>
    </header>

    <main class="detail-main">
      <section class="hero-wrap">
        <img
          :src="orderImage(order.img)"
          alt=""
          @error="onImageError"
        >
        <em>{{ rateText }}</em>
      </section>

      <section class="info-card">
        <div class="info-row">
          <span>{{ $t('shopOrders.unitPrice') }} :</span>
          <strong>{{ formatMoney(order.price) }}</strong>
        </div>
        <div class="info-row">
          <span>{{ $t('shopOrders.quantity') }} :</span>
          <strong>{{ order.num || 0 }}</strong>
        </div>
        <div class="info-row">
          <span>{{ $t('shopOrders.orderValue') }} :</span>
          <strong>{{ formatMoney(order.total) }}</strong>
        </div>
        <div class="info-row">
          <span>{{ $t('shopOrders.profit') }} :</span>
          <strong>{{ formatMoney(order.fee) }}</strong>
        </div>
        <div class="info-row">
          <span>{{ $t('shopOrders.returnAmount') }} :</span>
          <strong>{{ formatMoney(order.ret) }}</strong>
        </div>
        <div class="info-row">
          <span>{{ $t('shopOrders.status') }} :</span>
          <strong>{{ statusLabel(order.stat) }}</strong>
        </div>
        <div class="info-row">
          <span>{{ $t('shopOrders.bookingTime') }} :</span>
          <strong>{{ formatBrowserTime(order.ctime) }}</strong>
        </div>
        <div
          v-if="hasPaidTime"
          class="info-row"
        >
          <span>{{ $t('shopOrders.paymentTime') }} :</span>
          <strong>{{ formatBrowserTime(order.paytm) }}</strong>
        </div>
      </section>

      <section
        v-if="cashes.length"
        class="cash-scroll-card"
      >
        <van-icon
          name="volume-o"
          size="20"
        />
        <van-swipe
          class="cash-swipe"
          :autoplay="2000"
          :height="50"
          :show-indicators="false"
          :touchable="false"
          vertical
        >
          <van-swipe-item
            v-for="item in cashes"
            :key="item.id"
          >
            <div class="cash-item">
              <span>{{ item.acc }}</span>
              <strong>{{ $t('shopOrders.rebate') }} {{ formatMoney(item.money) }}</strong>
              <time>{{ item.displayTime }}</time>
            </div>
          </van-swipe-item>
        </van-swipe>
      </section>
    </main>

    <button
      v-if="Number(order.stat) === 0"
      type="button"
      class="ship-btn"
      :disabled="shipping"
      @click="shipOrder"
    >
      {{ $t('shopOrders.ship') }}
    </button>

    <FloatingCustomerService
      :service-url="app.kefu"
      :bottom="156"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import FloatingCustomerService from '../../components/FloatingCustomerService.vue';
import { Icon, Swipe, SwipeItem, Toast } from 'vant';

Vue.use(Icon).use(Swipe).use(SwipeItem).use(Toast);

export default {
  name: 'Shopodetail',
  components: {
    FloatingCustomerService,
  },
  data() {
    return {
      app: {},
      cashes: [],
      order: {},
      shipping: false,
      fallback: require('../images/shop2/pro.png'),
    };
  },
  computed: {
    detailTitle() {
      return this.order.title || this.$t('shopOrders.detailTitle');
    },
    rateText() {
      var rate = Number(this.order.rate || 0);
      if (!isFinite(rate)) rate = 0;
      return rate.toFixed(rate % 1 === 0 ? 0 : 2) + '%';
    },
    hasPaidTime() {
      return Number(this.order.paytm) > 0;
    },
  },
  created() {
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer('walfare', false);
    }
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data || {};
      });
      this.loadDetail();
    },
    loadDetail() {
      Fetch('/user/shop_order_detail', {
        id: this.$route.query.id || 0,
      }, null, true).then((r) => {
        this.order = (r.data && r.data.order) || {};
        this.cashes = this.normalizeCashes((r.data && r.data.cashes) || []);
      });
    },
    normalizeCashes(cashes) {
      if (!Array.isArray(cashes)) {
        return [];
      }
      return cashes.filter((item) => item && item.acc).map((item, index) => {
        var money = Number(item.money);
        if (!isFinite(money)) {
          money = 0;
        }
        return {
          id: item.id || (index + '-' + item.acc + '-' + money),
          acc: item.acc,
          money: money,
          displayTime: this.randomRecentTime(index),
        };
      });
    },
    randomRecentTime(index) {
      var minute = 60 * 1000;
      var twoDays = 48 * 60 * minute;
      var offset = (index % 30) * minute;
      var range = Math.max(twoDays - offset, minute);
      var time = new Date(Date.now() - Math.floor(Math.random() * range) - offset);
      var month = String(time.getMonth() + 1).padStart(2, '0');
      var day = String(time.getDate()).padStart(2, '0');
      var hour = String(time.getHours()).padStart(2, '0');
      var minuteText = String(time.getMinutes()).padStart(2, '0');
      return month + '-' + day + ' ' + hour + ':' + minuteText;
    },
    shipOrder() {
      if (this.shipping) return;
      this.shipping = true;
      Fetch('/user/shop_order_ship', {
        id: this.order.id,
      }, null, true).then(() => {
        Toast(this.$t('shopOrders.shipSuccess'));
        this.loadDetail();
      }).finally(() => {
        this.shipping = false;
      });
    },
    statusLabel(stat) {
      var map = {
        0: 'shopOrders.pending',
        1: 'shopOrders.waiting',
        2: 'shopOrders.staying',
        3: 'shopOrders.canceled',
        4: 'shopOrders.completed',
      };
      return this.$t(map[Number(stat)] || 'shopOrders.pending');
    },
    formatMoney(value) {
      var number = Number(value);
      if (!isFinite(number)) number = 0;
      return number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    orderImage(path) {
      if (!path) return this.fallback;
      if (/^(https?:)?\/\//.test(path) || String(path).indexOf('data:') === 0) {
        return path;
      }
      if (this.app && this.app.domain) {
        return this.app.domain.replace(/\/$/, '') + '/' + String(path).replace(/^\//, '');
      }
      return path;
    },
    onImageError(event) {
      event.target.src = this.fallback;
    },
  },
};
</script>

<style lang="less" scoped>
.shop-order-detail {
  min-height: 100vh;
  padding-bottom: 84px;
  background: #eaf4ff;
  color: #061429;
}

.detail-head {
  height: 56px;
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f7fc;
  border-bottom: 1px solid #e8ebf0;
}

.detail-head .van-icon {
  position: absolute;
  left: 24px;
  top: 18px;
  font-size: 22px;
  color: #061429;
}

.detail-head h1 {
  max-width: 310px;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  line-height: 56px;
  font-weight: 500;
}

.detail-main {
  padding-bottom: 24px;
}

.hero-wrap {
  position: relative;
  height: 265px;
  overflow: hidden;
  background: #dbe4ef;
}

.hero-wrap img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.hero-wrap em {
  position: absolute;
  right: 16px;
  top: 16px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #f80718;
  color: #fff;
  font-style: normal;
  font-size: 12px;
  line-height: 52px;
  text-align: center;
  font-weight: 700;
}

.info-card {
  margin: 12px 14px 0;
  padding: 24px 26px 18px;
  border-radius: 10px;
  background: #fffceb;
}

.info-row {
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dashed rgba(209, 213, 219, .7);
  font-size: 14px;
  line-height: 20px;
}

.info-row span {
  color: #596273;
}

.info-row strong {
  color: #050b18;
  font-size: 14px;
  font-weight: 500;
}

.cash-scroll-card {
  height: 50px;
  margin: 12px 14px 0;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  column-gap: 12px;
  padding: 0 18px;
  border-radius: 8px;
  background: #fff;
  box-sizing: border-box;
  color: #9ca3af;
  font-size: 12px;
}

.cash-scroll-card .van-icon {
  color: #805cff;
  font-size: 26px;
}

.cash-swipe {
  min-width: 0;
  height: 50px;
}

.cash-item {
  height: 50px;
  display: grid;
  grid-template-columns: minmax(54px, 1fr) auto 68px;
  align-items: center;
  column-gap: 8px;
  min-width: 0;
  line-height: 50px;
}

.cash-item span {
  min-width: 0;
  overflow: hidden;
  color: #9ca3af;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cash-item strong {
  overflow: hidden;
  color: #805cff;
  font-size: 12px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cash-item time {
  color: #9ca3af;
  font-size: 12px;
  text-align: right;
  white-space: nowrap;
}

.ship-btn {
  position: fixed;
  right: 24px;
  bottom: 14px;
  z-index: 10;
  width: 150px;
  height: 54px;
  border: 0;
  border-radius: 28px;
  background: linear-gradient(90deg, #ff6a33 0%, #f80726 100%);
  color: #fff;
  font-size: 14px;
  line-height: 54px;
  text-align: center;
  font-weight: 700;
}

.ship-btn:disabled {
  opacity: .65;
}

</style>
